// Tiny helper that turns a Blob into a download click. Lives in lib/
// so the workout export and the future cross-module report both reuse
// the same DOM dance without each duplicating the createObjectURL +
// click + revoke cleanup.
export function downloadTextFile(filename, text, mime = 'text/markdown;charset=utf-8') {
  const blob = new Blob([text], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  // Revoke on the next tick — Safari occasionally cancels the
  // download if you revoke synchronously.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
